








import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
const zhCN = require('ant-design-vue/lib/locale-provider/zh_CN');
const enUS = require('ant-design-vue/lib/locale-provider/en_US');
import { setSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import { usePush } from 'vue-baidu-analytics';

import moment from 'moment';
require('moment/locale/zh-cn');

@Component
export default class App extends Vue {
  @Provide() public reloadPage = this.reload;
  @Provide() public config = config;
  @Provide() public baidu = usePush();

  public isRouterAlive = true;

  public created() {
    this.setSchool();
  }

  public updated() {
    this.setSchool();
  }

  @Watch('$route', { immediate: false })
  public setSchool() {
    const shortName = this.$route.params.id;
    if (config[shortName]) {
      setSchoolInfo({
        schoolId: config[shortName].schoolId,
        name: config[shortName].schoolName,
        enName: config[shortName].schoolEnName,
        shortName,
      });
    }
  }

  public get locale(): object {
    const locale = this.$i18n.locale;
    if (locale === 'en') {
      moment.locale('en');
      return enUS.default;
    } else {
      moment.locale('zh-cn');
      return zhCN.default;
    }
  }

  public reload(): void {
    this.isRouterAlive = false;
    this.$nextTick(() => {
      this.isRouterAlive = true;
    });
  }
}
